// 🏠 App Shell - Layout principal de la aplicación
import { useState, useEffect } from 'react';
import { Sidebar } from '../navigation/Sidebar';
import { PaletaComandos } from '../navigation/PaletaComandos';
import { Header } from './Header';
import { TabSystem } from './TabSystem';
import { useThemeStore } from '@/stores/theme.store';

interface AppShellProps {
  children: React.ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  // Preferencia persistente: el sidebar recuerda si estaba contraído
  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    () => localStorage.getItem('erp_sidebar_collapsed') === '1'
  );
  const { theme } = useThemeStore();

  // Aplicar tema al montar
  useEffect(() => {
    const { applyTheme } = useThemeStore.getState();
    applyTheme(theme);
  }, [theme]);

  const toggleSidebar = () =>
    setSidebarCollapsed((prev) => {
      localStorage.setItem('erp_sidebar_collapsed', prev ? '0' : '1');
      return !prev;
    });

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* Sidebar dinámico */}
      <Sidebar isCollapsed={sidebarCollapsed} />

      {/* Main content */}
      <div className="flex flex-1 flex-col overflow-hidden">
        {/* Header */}
        <Header onMenuClick={toggleSidebar} />

        {/* Tabs */}
        <TabSystem />

        {/* Content */}
        <main className="flex-1 overflow-y-auto p-6">
          {children}
        </main>
      </div>

      {/* Buscador global (Ctrl/⌘+K). Se monta siempre: es quien escucha el atajo. */}
      <PaletaComandos />
    </div>
  );
}
